export default __webpack_public_path__ + "static/core-values-cover-960085bf467c50a7b6db2323881f6d81.jpg";